import Skeleton from 'react-loading-skeleton';
import React from 'react';

export const Loader = () => (
  <div className='flex items-start justify-center gap-[24px] py-[24px] px-[24px] w-full h-full'>
    <Skeleton width='400px' height='500px' />
    <Skeleton width='400px' height='500px' />
  </div>
);
